module.exports = __webpack_public_path__ + "static/rebase-banner-84b452f90e4c139c719d22450756f93a.svg";